import getSupportURL, { type SupportURLPathType } from '@/constants/support-urls';

import Link, { type LinkProps } from './Link';

type Props = Omit<LinkProps, 'to' | 'previousPage'> & {
  path: SupportURLPathType;
};

const SupportLink = ({ path, ...props }: Props) => {
  return (
    <Link
      to={getSupportURL(path)}
      color="static-green"
      target="_blank"
      showExternalIcon
      {...props}
    />
  );
};

export default SupportLink;
